import { copyComponentUrl } from '@fluidx/host-ux';
import type { CommandProps } from '@fluidx/office-fluid-types';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { copyText, removeText } from './getActionMenuItems.locstring.json';
import { FluidOwaSource } from 'owa-fluid-validations';
import { assertNever } from 'owa-assert';

export function getActionMenuItems(
    owaSource: FluidOwaSource,
    url?: string,
    deleteNode?: () => void,
    customMenuItems?: CommandProps[]
): CommandProps[] {
    let menuItems: CommandProps[] = [];
    if (url) {
        menuItems.push({
            displayName: loc(copyText),
            id: 'copy',
            icon: ControlIcons.Copy,
            execute: () => {
                copyComponentUrl(url);
            },
        });
    }

    if (shouldShowDeleteOption(owaSource) && deleteNode) {
        menuItems.push({
            displayName: loc(removeText),
            id: loc(removeText),
            icon: ControlIcons.Delete,
            execute: deleteNode,
        });
    }

    if (customMenuItems?.length && customMenuItems.length > 0) {
        menuItems = menuItems.concat(customMenuItems);
    }

    return menuItems;
}

function shouldShowDeleteOption(owaSource: FluidOwaSource) {
    switch (owaSource) {
        case FluidOwaSource.MailCompose:
        case FluidOwaSource.AgendaEditor:
            return true;
        case FluidOwaSource.MailReadingPane:
        case FluidOwaSource.CalendarCompose:
        case FluidOwaSource.MailCalendarCard:
        case FluidOwaSource.CalendarReadingPane:
        case FluidOwaSource.Timestream:
        case FluidOwaSource.None:
            return false;
        default:
            return assertNever(owaSource);
    }
}
